import React, { useCallback } from "react"
import { Card, CardMedia, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import clsx from "clsx"
import { Link } from "react-router-dom"
import { get } from "lodash"
import { GTM_VIEW_POST } from "constant"
import { pushDataLayer } from "utils/googletagmanager"

export const LuxuryCard = ({ data, sx = {}, ...props }) => {
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components?.[`LuxuryCard`] || {}
  const { root, cardMedia, logo } = styleOverrides
  const locationPath = data?.locationUrl
  const hasLogo = data?.locationLinkInfo?.image

  const handleClick = useCallback(() => {
    pushDataLayer({
      event: GTM_VIEW_POST,
      post_type: get(data, "type"),
      post_category: get(data, "category.en"),
      post_id: get(data, "id"),
      post_title: get(data, "title.en"),
    })
  }, [data])

  return (
    <Card
      sx={deepmerge(root, sx)}
      {...props}
      className={clsx(hasLogo ? "with-logo" : "")}
      component={Link}
      to={locationPath}
      onClick={handleClick}
    >
      <CardMedia sx={cardMedia} image={data?.featureImage} />
      <CardMedia sx={logo} image={data?.locationLinkInfo?.image} />
    </Card>
  )
}
